const pathUrl = {
    baseUrl:"https://clinsr.idrblab.cn/api",
    // baseUrl:"http://127.0.0.1:9006/api",
    localUrl:"https://clinsr.idrblab.cn",
}

export default pathUrl;